import React from 'react';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import AnimationIcon from '@mui/icons-material/Animation';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ChatIcon from '@mui/icons-material/Chat';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import ImageIcon from '@mui/icons-material/Image';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import TimerIcon from '@mui/icons-material/Timer';
import UpdateIcon from '@mui/icons-material/Update';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import i18n from 'i18n-js';

import CountdownLolWorldsImage from '../../assets/countdown/countdown-lolworlds.png';
import CountdownLolWorldsSimpleImage from '../../assets/countdown/countdown-lolworldssimple.png';
import CountdownNewWorldImage from '../../assets/countdown/countdown-newworld.png';

import ConfettiLogo from '../../components/Logos/Confetti';
import GbestLogo from '../../components/Logos/Gbest';
import OreEsportsLogo from '../../components/Logos/OreEsports';
import PamplingLogo from '../../components/Logos/Pampling';
import C from '../constants';
import {
  AI_TEMPLATES,
  AI_TEMPLATES_IMAGES,
  AI_TEMPLATES_TITLES,
} from './ai';
import {
  ALERTBOX_TEMPLATES,
  ALERTBOX_TEMPLATES_IMAGES,
  ALERTBOX_TEMPLATES_TITLES,
} from './alertBox';
import {
  AMERICANFOOTBALL_TEMPLATES,
  AMERICANFOOTBALL_TEMPLATES_IMAGES,
  AMERICANFOOTBALL_TEMPLATES_TITLES,
} from './americanFootball';
import {
  ANIMATED_TEMPLATES,
  ANIMATED_TEMPLATES_IMAGES,
  ANIMATED_TEMPLATES_TITLES,
} from './animated';
import {
  BASEBALL_TEMPLATES,
  BASEBALL_TEMPLATES_IMAGES,
  BASEBALL_TEMPLATES_TITLES,
} from './baseball';
import {
  CHAT_TEMPLATES,
  CHAT_TEMPLATES_IMAGES,
  CHAT_TEMPLATES_TITLES,
} from './chat';
import {
  COINFLIP_TEMPLATES,
  COINFLIP_TEMPLATES_IMAGES,
  COINFLIP_TEMPLATES_TITLES,
} from './coinFlip';
import {
  CONFETTI_TEMPLATES,
  CONFETTI_TEMPLATES_IMAGES,
  CONFETTI_TEMPLATES_TITLES,
} from './confetti';
import {
  COUNT_UP_TEMPLATES,
  COUNT_UP_TEMPLATES_IMAGES,
  COUNT_UP_TEMPLATES_TITLES,
} from './countUp';
import {
  FORTNITE_TEMPLATES,
  FORTNITE_TEMPLATES_IMAGES,
  FORTNITE_TEMPLATES_TITLES,
} from './fortnite';
import {
  GBEST_TEMPLATES,
  GBEST_TEMPLATES_IMAGES,
  GBEST_TEMPLATES_TITLES,
} from './gbest';
import {
  ORE_ESPORTS_TEMPLATES,
  ORE_ESPORTS_TEMPLATES_IMAGES,
  ORE_ESPORTS_TEMPLATES_TITLES,
} from './oreEsports';
import {
  PAMPLING_TEMPLATES,
  PAMPLING_TEMPLATES_IMAGES,
  PAMPLING_TEMPLATES_TITLES,
} from './pampling';
import {
  QUIZ_TEMPLATES,
  QUIZ_TEMPLATES_IMAGES,
  QUIZ_TEMPLATES_TITLES,
} from './quiz';
import {
  WORDGUESSING_TEMPLATES,
  WORDGUESSING_TEMPLATES_IMAGES,
  WORDGUESSING_TEMPLATES_TITLES,
} from './wordGuessing';

const { GBEST, PHOTOAI } = C.AFILIATES;

export const TEMPLATES_GROUP_TITLES = {
  AI: 'ai',
  ALERTBOX: 'alertbox',
  AMERICANFOOTBALL: 'americanFootball',
  ANIMATED: 'animated',
  BASEBALL: 'baseball',
  BASKETBALL: 'basketball',
  CHAT: 'chat',
  COINFLIP: 'coinflip',
  CONFETTI: 'confetti',
  CONTROLLER: 'controller',
  COUNTDOWN: 'countdown',
  COUNTUP: 'countup',
  FORTNITE: 'fortnite',
  GBEST: 'gbest',
  GIVEAWAY: 'giveaway',
  MEDIALOOP: 'medialoop',
  ORE: 'ore',
  PADEL: 'padel',
  PAMPLING: 'pampling',
  QUESTION: 'question',
  QUIZ: 'quiz',
  ROULETTE: 'roulette',
  SOCCER: 'soccer',
  WORDGUESSING: 'wordguessing',
};

export const TEMPLATES_TITLES = {
  ...AI_TEMPLATES_TITLES,
  ...ALERTBOX_TEMPLATES_TITLES,
  ...AMERICANFOOTBALL_TEMPLATES_TITLES,
  ...ANIMATED_TEMPLATES_TITLES,
  ...BASEBALL_TEMPLATES_TITLES,
  ...CHAT_TEMPLATES_TITLES,
  ...COINFLIP_TEMPLATES_TITLES,
  ...CONFETTI_TEMPLATES_TITLES,
  ...COUNT_UP_TEMPLATES_TITLES,
  ...FORTNITE_TEMPLATES_TITLES,
  ...GBEST_TEMPLATES_TITLES,
  ...ORE_ESPORTS_TEMPLATES_TITLES,
  ...PAMPLING_TEMPLATES_TITLES,
  ...QUIZ_TEMPLATES_TITLES,
  ...WORDGUESSING_TEMPLATES_TITLES,
  BASKETBALL_EUROLEAGUE: 'basketball-euroleague',
  BASKETBALL_LEBPLATA: 'basketball-lebplata',
  BASKETBALL_LIGAENDESA: 'basketball-ligaendesa',
  BASKETBALL_NBA: 'basketball-nba',
  BASKETBALL_SIMPLE: 'basketball-simple',
  BASKETBALL_SPANISHCUP: 'basketball-spanishcup',
  CONTROLLER_PS4: 'controller-ps4',
  CONTROLLER_PS4MILITARY: 'controller-ps4military',
  CONTROLLER_PS5: 'controller-ps5',
  COUNTDOWN_ARTIFICIALINTELLIGENCE: 'countdown-artificialintelligence',
  COUNTDOWN_BATTERY: 'countdown-battery',
  COUNTDOWN_BOMB: 'countdown-bomb',
  COUNTDOWN_BOXINGRING: 'countdown-boxingring',
  COUNTDOWN_CHRISTMASBALL: 'countdown-christmasball',
  COUNTDOWN_CHRISTMASHAT: 'countdown-christmashat',
  COUNTDOWN_CHRISTMASPRESENT: 'countdown-christmaspresent',
  COUNTDOWN_CUSTOMBACKGROUND: 'countdown-custombackground',
  COUNTDOWN_DIGITAL: 'countdown-digital',
  COUNTDOWN_GENSHIN: 'countdown-genshin',
  COUNTDOWN_GENSHINSIMPLE: 'countdown-genshinsimple',
  COUNTDOWN_HALLOWEEN: 'countdown-halloween',
  COUNTDOWN_KARMALAND: 'countdown-karmaland',
  COUNTDOWN_KINGSLEAGUE: 'countdown-kingsleague',
  COUNTDOWN_LOLWORLDS: 'countdown-lolworlds',
  COUNTDOWN_LOLWORLDSSIMPLE: 'countdown-lolworldssimple',
  COUNTDOWN_MINECRAFT: 'countdown-minecraft',
  COUNTDOWN_NEONSIMPLE: 'countdown-neonsimple',
  COUNTDOWN_NEWWORLD: 'countdown-newworld',
  COUNTDOWN_SIMPLE: 'countdown-simple',
  COUNTDOWN_SQUIDCRAFT: 'countdown-squidcraft',
  COUNTDOWN_THEGREFG: 'countdown-thegrefg',
  COUNTDOWN_THEGREFGDRAGONBALL: 'countdown-thegrefgdragonball',
  COUNTDOWN_WITHOUTBACKGROUND: 'countdown-withoutbackground',
  GIVEAWAY_SIMPLE: 'giveaway-simple',
  MEDIALOOP_SIMPLE: 'medialoop-simple',
  MEDIALOOP_SOCIALMEDIA: 'medialoop-socialmedia',
  PADEL_SIMPLE: 'padel-simple',
  PADEL_WORLD_PADEL_TOUR_2021: 'padel-world-padel-tour-2021',
  QUESTION_SIMPLE: 'question-simple',
  QUESTION_TWITCH: 'question-twitch',
  ROULETTE_CASINO: 'roulette-casino',
  ROULETTE_LOGO: 'roulette-logo',
  ROULETTE_SIMPLE: 'roulette-simple',
  SOCCER_ARGENTINALEAGUE: 'soccer-argentinaleague',
  SOCCER_ARGENTINALEAGUE2023: 'soccer-argentinaleague2023',
  SOCCER_ARGENTINAPRIMERANACIONAL2023: 'soccer-argentinaprimeranacional2023',
  SOCCER_CHAMPIONSLEAGUE: 'soccer-championsleague',
  SOCCER_CHAMPIONSLEAGUE2025: 'soccer-championsleague2025',
  SOCCER_COPAAMERICA2024: 'soccer-copaamerica2024',
  SOCCER_COPAREY: 'soccer-coparey',
  SOCCER_COPAREY2023: 'soccer-coparey2023',
  SOCCER_EUROCUP2024: 'soccer-eurocup2024',
  SOCCER_EUROPALEAGUE: 'soccer-europaleague',
  SOCCER_KINGDOMCUP: 'soccer-kingdomcup',
  SOCCER_KINGSLEAGUE: 'soccer-kingsleague',
  SOCCER_KINGSLEAGUE2SPLIT: 'soccer-kingsleague2split',
  SOCCER_KINGSLEAGUE3SPLIT: 'soccer-kingsleague3split',
  SOCCER_SIMPLE: 'soccer-simple',
  SOCCER_LALIGA: 'soccer-laliga',
  SOCCER_LALIGAEASPORTS: 'soccer-laligaeasports',
  SOCCER_LALIGAHYPERMOTION: 'soccer-laligahypermotion',
  SOCCER_LALIGASMARTBANK: 'soccer-laligasmartbank',
  SOCCER_LALIGUE1: 'soccer-laligue1',
  SOCCER_PREMIERLEAGUE: 'soccer-premierleague',
  SOCCER_PREMIERLEAGUE2024: 'soccer-premierleague2024',
  SOCCER_QUEENSLEAGUE: 'soccer-queensleague',
  SOCCER_SERIEA: 'soccer-seriea',
  SOCCER_SUPERCOPA2023: 'soccer-supercopa2023',
  SOCCER_EUFA_EURO_2020: 'soccer-eufa-euro-2020',
  SOCCER_WORLDCUP2022: 'soccer-worldcup2020',
  SOCCER_WORLDCUP2022OFFICIAL: 'soccer-worldcup2022official',
};

const FortniteLogo = ({ className }) => (
  <svg
    className={`MuiSvgIcon-root ${className}`}
    width="19"
    height="48"
    viewBox="0 0 19 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 24C0 37.2027 0.0316491 48 0.0738479 48C0.137146 48 8.73515 46.3565 9.79012 46.1388L10.3387 46.0299V28.4082H16.8795V26.7973C16.8795 25.9156 16.9112 23.619 16.9534 21.6816L17.0167 18.1769H10.3387V10.449H14.1893C16.3098 10.449 18.04 10.4272 18.04 10.3946C18.04 10.2748 18.884 0.979592 18.9367 0.511565L19 0H0V24Z" />
  </svg>
);

export const TEMPLATES_GROUP = [
  {
    Icon: AutoAwesomeIcon,
    id: TEMPLATES_GROUP_TITLES.AI,
    title: i18n.t('screens.templates.ai.title'),
  },
  {
    Icon: AddAlertIcon,
    id: TEMPLATES_GROUP_TITLES.ALERTBOX,
    title: i18n.t('screens.templates.alertbox.title'),
  },
  {
    Icon: SportsFootballIcon,
    id: TEMPLATES_GROUP_TITLES.AMERICANFOOTBALL,
    title: i18n.t('screens.templates.americanfootball.title'),
  },
  {
    Icon: AnimationIcon,
    id: TEMPLATES_GROUP_TITLES.ANIMATED,
    title: i18n.t('screens.templates.animated.title'),
  },
  {
    Icon: SportsBaseballIcon,
    id: TEMPLATES_GROUP_TITLES.BASEBALL,
    title: i18n.t('screens.templates.baseball.title'),
  },
  {
    Icon: ChatIcon,
    id: TEMPLATES_GROUP_TITLES.CHAT,
    title: i18n.t('screens.templates.chat.title'),
  },
  {
    Icon: TimerIcon,
    id: TEMPLATES_GROUP_TITLES.COUNTDOWN,
    title: i18n.t('screens.templates.countdown.title'),
    youtubeVideoId: 'jX0br1nBkqY',
  },
  {
    Icon: UpdateIcon,
    id: TEMPLATES_GROUP_TITLES.COUNTUP,
    title: i18n.t('screens.templates.countup.title'),
  },
  {
    Icon: CardGiftcardIcon,
    id: TEMPLATES_GROUP_TITLES.GIVEAWAY,
    title: i18n.t('screens.templates.giveaway.title'),
  },
  {
    Icon: SportsEsportsIcon,
    id: TEMPLATES_GROUP_TITLES.CONTROLLER,
    title: i18n.t('screens.templates.controller.title'),
  },
  {
    Icon: QuestionAnswerIcon,
    id: TEMPLATES_GROUP_TITLES.QUESTION,
    title: i18n.t('screens.templates.question.title'),
    youtubeVideoId: 'T2va9EOsyz4',
  },
  {
    Icon: FortniteLogo,
    id: TEMPLATES_GROUP_TITLES.FORTNITE,
    title: i18n.t('screens.templates.fortnite.title'),
  },
  {
    Icon: ImageIcon,
    id: TEMPLATES_GROUP_TITLES.MEDIALOOP,
    title: i18n.t('screens.templates.medialoop.title'),
    youtubeVideoId: '3WI09Aii8wg',
  },
  {
    Icon: DonutSmallIcon,
    id: TEMPLATES_GROUP_TITLES.ROULETTE,
    title: i18n.t('screens.templates.roulette.title'),
    youtubeVideoId: '3kk84bksE_M',
  },
  {
    Icon: FlipCameraAndroidIcon,
    id: TEMPLATES_GROUP_TITLES.COINFLIP,
    title: i18n.t('screens.templates.coinflip.title'),
  },
  {
    Icon: ConfettiLogo,
    id: TEMPLATES_GROUP_TITLES.CONFETTI,
    title: i18n.t('screens.templates.confetti.title'),
  },
  {
    Icon: SportsSoccerIcon,
    id: TEMPLATES_GROUP_TITLES.SOCCER,
    title: i18n.t('screens.templates.soccer.title'),
    youtubeVideoId: 'k92kf2ROpaE',
  },
  {
    Icon: SportsBasketballIcon,
    id: TEMPLATES_GROUP_TITLES.BASKETBALL,
    title: i18n.t('screens.templates.basketball.title'),
    youtubeVideoId: 'k92kf2ROpaE',
  },
  {
    Icon: SportsTennisIcon,
    id: TEMPLATES_GROUP_TITLES.PADEL,
    title: i18n.t('screens.templates.padel.title'),
    youtubeVideoId: 'k92kf2ROpaE',
  },
  {
    Icon: PamplingLogo,
    id: TEMPLATES_GROUP_TITLES.PAMPLING,
    title: i18n.t('screens.templates.pampling.title'),
  },
  {
    Icon: GbestLogo,
    id: TEMPLATES_GROUP_TITLES.GBEST,
    title: i18n.t('screens.templates.gbest.title'),
  },
  {
    Icon: OreEsportsLogo,
    id: TEMPLATES_GROUP_TITLES.ORE,
    title: i18n.t('screens.templates.ore.title'),
  },
  {
    Icon: FontDownloadIcon,
    id: TEMPLATES_GROUP_TITLES.WORDGUESSING,
    title: i18n.t('screens.templates.wordguessing.title'),
  },
  {
    Icon: ViewCompactIcon,
    id: TEMPLATES_GROUP_TITLES.QUIZ,
    title: i18n.t('screens.templates.quiz.title'),
  },
];

export const TEMPLATES_IMAGES = {
  ...AI_TEMPLATES_IMAGES,
  ...ALERTBOX_TEMPLATES_IMAGES,
  ...AMERICANFOOTBALL_TEMPLATES_IMAGES,
  ...ANIMATED_TEMPLATES_IMAGES,
  ...BASEBALL_TEMPLATES_IMAGES,
  ...CHAT_TEMPLATES_IMAGES,
  ...COINFLIP_TEMPLATES_IMAGES,
  ...CONFETTI_TEMPLATES_IMAGES,
  ...COUNT_UP_TEMPLATES_IMAGES,
  ...FORTNITE_TEMPLATES_IMAGES,
  ...GBEST_TEMPLATES_IMAGES,
  ...ORE_ESPORTS_TEMPLATES_IMAGES,
  ...PAMPLING_TEMPLATES_IMAGES,
  ...QUIZ_TEMPLATES_IMAGES,
  ...WORDGUESSING_TEMPLATES_IMAGES,
  [TEMPLATES_TITLES.BASKETBALL_EUROLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-euroleague-1.webp',
  [TEMPLATES_TITLES.BASKETBALL_LEBPLATA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-lebplata-1.webp',
  [TEMPLATES_TITLES.BASKETBALL_LIGAENDESA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-ligaendesa-1.webp',
  [TEMPLATES_TITLES.BASKETBALL_NBA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-nba-1.webp',
  [TEMPLATES_TITLES.BASKETBALL_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-simple-1.webp',
  [TEMPLATES_TITLES.BASKETBALL_SPANISHCUP]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-spanishcup-1.webp',
  [TEMPLATES_TITLES.CONTROLLER_PS4]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4-1.webp',
  [TEMPLATES_TITLES.CONTROLLER_PS4MILITARY]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4military-1.webp',
  [TEMPLATES_TITLES.CONTROLLER_PS5]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_ARTIFICIALINTELLIGENCE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-artificialintelligence-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_BATTERY]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-battery-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_BOMB]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-bomb-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_BOXINGRING]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-boxingring-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASBALL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmasball-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASHAT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmashat-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASPRESENT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmaspresent-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_CUSTOMBACKGROUND]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-custombackground-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_DIGITAL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-digital-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_GENSHIN]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshin-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_GENSHINSIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshinsimple-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_HALLOWEEN]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-halloween-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_KARMALAND]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-karmaland-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_KINGSLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-kingsleague-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDS]: CountdownLolWorldsImage,
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDSSIMPLE]: CountdownLolWorldsSimpleImage,
  [TEMPLATES_TITLES.COUNTDOWN_MINECRAFT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-minecraft-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_NEONSIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-neonsimple-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_NEWWORLD]: CountdownNewWorldImage,
  [TEMPLATES_TITLES.COUNTDOWN_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-simple-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_SQUIDCRAFT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFG]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefg-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFGDRAGONBALL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefgdragonball-1.webp',
  [TEMPLATES_TITLES.COUNTDOWN_WITHOUTBACKGROUND]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-withoutbackground-1.webp',
  [TEMPLATES_TITLES.GIVEAWAY_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/giveaway-simple-1.webp',
  [TEMPLATES_TITLES.MEDIALOOP_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-simple-1.webp',
  [TEMPLATES_TITLES.MEDIALOOP_SOCIALMEDIA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-socialmedia-1.webp',
  [TEMPLATES_TITLES.PADEL_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/padel-simple-1.webp',
  [TEMPLATES_TITLES.PADEL_WORLD_PADEL_TOUR_2021]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/padel-world-padel-tour-2021-1.webp',
  [TEMPLATES_TITLES.QUESTION_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/question-simple-1.webp',
  [TEMPLATES_TITLES.QUESTION_TWITCH]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/question-twitch-1.webp',
  [TEMPLATES_TITLES.ROULETTE_CASINO]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-casino-1.webp',
  [TEMPLATES_TITLES.ROULETTE_LOGO]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-logo-1.webp',
  [TEMPLATES_TITLES.ROULETTE_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-simple-1.webp',
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE2023]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague2023-1.webp',
  [TEMPLATES_TITLES.SOCCER_ARGENTINAPRIMERANACIONAL2023]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaPrimeraNacional2023-1.webp',
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE2025]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague2025-1.webp',
  [TEMPLATES_TITLES.SOCCER_COPAAMERICA2024]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-copaamerica2024-1.webp',
  [TEMPLATES_TITLES.SOCCER_COPAREY]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey-1.webp',
  [TEMPLATES_TITLES.SOCCER_COPAREY2023]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey2023-1.webp',
  [TEMPLATES_TITLES.SOCCER_EUROCUP2024]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eurocup2024-1.webp',
  [TEMPLATES_TITLES.SOCCER_EUROPALEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-europaleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_KINGDOMCUP]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingdomcup-1.webp',
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE2SPLIT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague2split-1.webp',
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE3SPLIT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague3split-1.webp',
  [TEMPLATES_TITLES.SOCCER_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-simple-1.webp',
  [TEMPLATES_TITLES.SOCCER_LALIGA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laliga-1.webp',
  [TEMPLATES_TITLES.SOCCER_LALIGAEASPORTS]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligaeasports-1.webp',
  [TEMPLATES_TITLES.SOCCER_LALIGAHYPERMOTION]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligahypermotion-1.webp',
  [TEMPLATES_TITLES.SOCCER_LALIGASMARTBANK]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligasmartbank-1.webp',
  [TEMPLATES_TITLES.SOCCER_LALIGUE1]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligue1-1.webp',
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE2024]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague2024-1.webp',
  [TEMPLATES_TITLES.SOCCER_QUEENSLEAGUE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-queensleague-1.webp',
  [TEMPLATES_TITLES.SOCCER_SERIEA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-seriea-1.webp',
  [TEMPLATES_TITLES.SOCCER_SUPERCOPA2023]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-supercopa2023-1.webp',
  [TEMPLATES_TITLES.SOCCER_EUFA_EURO_2020]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eufa-euro-2020-1.webp',
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldcup2022-1.webp',
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022OFFICIAL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldCup2022official-1.webp',
};

export const TEMPLATES = {
  ...AI_TEMPLATES,
  ...ALERTBOX_TEMPLATES,
  ...AMERICANFOOTBALL_TEMPLATES,
  ...ANIMATED_TEMPLATES,
  ...BASEBALL_TEMPLATES,
  ...CHAT_TEMPLATES,
  ...COINFLIP_TEMPLATES,
  ...CONFETTI_TEMPLATES,
  ...COUNT_UP_TEMPLATES,
  ...FORTNITE_TEMPLATES,
  ...GBEST_TEMPLATES,
  ...ORE_ESPORTS_TEMPLATES,
  ...PAMPLING_TEMPLATES,
  ...QUIZ_TEMPLATES,
  ...WORDGUESSING_TEMPLATES,
  basketball: [
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t('screens.templates.basketball.spanishcup.description'),
      shortDescription: i18n.t(
        'screens.templates.basketball.spanishcup.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_SPANISHCUP,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-spanishcup-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-spanishcup-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-spanishcup-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-spanishcup-4.webp',
      ],
      link: PHOTOAI,
      referral: 'feb',
      title: i18n.t('screens.templates.basketball.spanishcup.title'),
      users: 4,
    },
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t('screens.templates.basketball.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.basketball.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.basketball.simple.title'),
      users: 7040,
    },
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t(
        'screens.templates.basketball.nba.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.basketball.nba.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_NBA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-nba-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-nba-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-nba-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-nba-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.basketball.nba.title'),
      users: 267,
    },
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t(
        'screens.templates.basketball.ligaendesa.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.basketball.ligaendesa.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_LIGAENDESA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-ligaendesa-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-ligaendesa-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-ligaendesa-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-ligaendesa-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.basketball.ligaendesa.title'),
      users: 677,
    },
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t(
        'screens.templates.basketball.lebplata.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.basketball.lebplata.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_LEBPLATA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-lebplata-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-lebplata-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-lebplata-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-lebplata-4.webp',
      ],
      link: PHOTOAI,
      referral: 'feb',
      title: i18n.t('screens.templates.basketball.lebplata.title'),
      users: 4,
    },
    {
      category: i18n.t('screens.templates.basketball.title'),
      description: i18n.t(
        'screens.templates.basketball.euroleague.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.basketball.euroleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.BASKETBALL_EUROLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-euroleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-euroleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-euroleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/basketball-euroleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.basketball.euroleague.title'),
      users: 1064,
    },
  ],
  controller: [
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.controller.ps5.description'),
      shortDescription: i18n.t(
        'screens.templates.controller.ps5.shortDescription'
      ),
      id: TEMPLATES_TITLES.CONTROLLER_PS5,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.controller.ps5.title'),
      users: 383,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.controller.ps4.description'),
      shortDescription: i18n.t(
        'screens.templates.controller.ps4.shortDescription'
      ),
      id: TEMPLATES_TITLES.CONTROLLER_PS4,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.controller.ps4.title'),
      users: 12248,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t(
        'screens.templates.controller.ps4military.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.controller.ps4military.shortDescription'
      ),
      id: TEMPLATES_TITLES.CONTROLLER_PS4MILITARY,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4military-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4military-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4military-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4military-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.controller.ps4military.title'),
      users: 58,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.pampling.ps4pampling.description'),
      shortDescription: i18n.t(
        'screens.templates.pampling.ps4pampling.shortDescription'
      ),
      id: PAMPLING_TEMPLATES_TITLES.CONTROLLER_PS4PAMPLING,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4pampling-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4pampling-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4pampling-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4pampling-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.pampling.ps4pampling.title'),
      users: 485,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.pampling.ps5pampling.description'),
      shortDescription: i18n.t(
        'screens.templates.pampling.ps4pampling.shortDescription'
      ),
      id: PAMPLING_TEMPLATES_TITLES.CONTROLLER_PS5PAMPLING,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5pampling-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5pampling-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5pampling-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5pampling-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.pampling.ps5pampling.title'),
      users: 459,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.gbest.ps4gbest.description'),
      shortDescription: i18n.t(
        'screens.templates.gbest.ps4gbest.shortDescription'
      ),
      id: TEMPLATES_TITLES.CONTROLLER_PS4GBEST,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4gbest-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4gbest-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4gbest-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4gbest-4.webp',
      ],
      link: GBEST,
      title: i18n.t('screens.templates.gbest.ps4gbest.title'),
      users: 241,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.gbest.ps5gbest.description'),
      shortDescription: i18n.t(
        'screens.templates.gbest.ps5gbest.shortDescription'
      ),
      id: GBEST_TEMPLATES_TITLES.CONTROLLER_PS5GBEST,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5gbest-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5gbest-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5gbest-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5gbest-4.webp',
      ],
      link: GBEST,
      title: i18n.t('screens.templates.gbest.ps5gbest.title'),
      users: 253,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.ore.ps4ore.description'),
      shortDescription: i18n.t('screens.templates.ore.ps4ore.shortDescription'),
      id: ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS4ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.ore.ps4ore.title'),
      users: 353,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.ore.ps5ore.description'),
      shortDescription: i18n.t('screens.templates.ore.ps5ore.shortDescription'),
      id: ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS5ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.ore.ps5ore.title'),
      users: 367,
    },
  ],
  countdown: [
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.artificialintelligence.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.artificialintelligence.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_ARTIFICIALINTELLIGENCE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-artificialintelligence-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-artificialintelligence-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-artificialintelligence-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-artificialintelligence-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.artificialintelligence.title'),
      users: 782,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.thegrefgdragonball.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.thegrefgdragonball.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_THEGREFGDRAGONBALL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefgdragonball-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefgdragonball-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefgdragonball-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefgdragonball-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.thegrefgdragonball.title'),
      users: 261,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.custombackground.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.custombackground.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_CUSTOMBACKGROUND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-custombackground-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-custombackground-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-custombackground-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-custombackground-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.custombackground.title'),
      users: 3655,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.kingsleague.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.kingsleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_KINGSLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-kingsleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-kingsleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-kingsleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-kingsleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.kingsleague.title'),
      users: 422,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.digital.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.digital.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_DIGITAL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-digital-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-digital-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-digital-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-digital-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.digital.title'),
      users: 25633,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownbus.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownbus.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEBUS,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownbus.title'),
      users: 728,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.thegrefg.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.thegrefg.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_THEGREFG,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefg-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefg-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefg-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-thegrefg-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.thegrefg.title'),
      users: 76546,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownisland.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownisland.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEISLAND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownisland.title'),
      users: 1419,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.squidcraft.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.squidcraft.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_SQUIDCRAFT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-squidcraft-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.squidcraft.title'),
      users: 139,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.boxingring.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.boxingring.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_BOXINGRING,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-boxingring-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-boxingring-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-boxingring-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-boxingring-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.boxingring.title'),
      users: 93,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.neonsimple.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.neonsimple.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_NEONSIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-neonsimple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-neonsimple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-neonsimple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-neonsimple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.neonsimple.title'),
      users: 602,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.withoutbackground.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.withoutbackground.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_WITHOUTBACKGROUND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-withoutbackground-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-withoutbackground-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-withoutbackground-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-withoutbackground-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.withoutbackground.title'),
      users: 23775,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.halloween.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.halloween.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_HALLOWEEN,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-halloween-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-halloween-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-halloween-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-halloween-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.halloween.title'),
      users: 1145,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.minecraft.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.minecraft.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_MINECRAFT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-minecraft-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-minecraft-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-minecraft-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-minecraft-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.minecraft.title'),
      users: 6988,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.pampling.countdown.description'),
      shortDescription: i18n.t(
        'screens.templates.pampling.countdown.shortDescription'
      ),
      id: PAMPLING_TEMPLATES_TITLES.COUNTDOWN_PAMPLING,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-pampling-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-pampling-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-pampling-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-pampling-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.pampling.countdown.title'),
      users: 901,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.karmaland.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.karmaland.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_KARMALAND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-karmaland-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-karmaland-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-karmaland-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-karmaland-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.karmaland.title'),
      users: 119,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.christmaspresent.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.christmaspresent.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_CHRISTMASPRESENT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmaspresent-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmaspresent-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmaspresent-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmaspresent-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.christmaspresent.title'),
      users: 699,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.genshin.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.genshin.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_GENSHIN,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshin-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshin-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshin-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshin-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.genshin.title'),
      users: 110,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.gbest.countdown.description'),
      shortDescription: i18n.t(
        'screens.templates.gbest.countdown.shortDescription'
      ),
      id: GBEST_TEMPLATES_TITLES.COUNTDOWN_GBEST,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-gbest-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-gbest-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-gbest-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-gbest-4.webp',
      ],
      link: GBEST,
      title: i18n.t('screens.templates.gbest.countdown.title'),
      users: 2882,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.ore.countdown.description'),
      shortDescription: i18n.t(
        'screens.templates.ore.countdown.shortDescription'
      ),
      id: ORE_ESPORTS_TEMPLATES_TITLES.COUNTDOWN_ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.ore.countdown.title'),
      users: 1777,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.christmasball.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.christmasball.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_CHRISTMASBALL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmasball-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmasball-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmasball-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmasball-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.christmasball.title'),
      users: 49,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownllama.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownllama.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITELLAMA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownllama.title'),
      users: 1805,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.battery.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.battery.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_BATTERY,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-battery-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-battery-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-battery-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-battery-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.battery.title'),
      users: 230,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.genshinsimple.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.genshinsimple.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_GENSHINSIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshinsimple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshinsimple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshinsimple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-genshinsimple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.genshinsimple.title'),
      users: 994,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.simple.title'),
      users: 4715,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.countdown.bomb.description'),
      shortDescription: i18n.t(
        'screens.templates.countdown.bomb.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_BOMB,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-bomb-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-bomb-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-bomb-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-bomb-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.bomb.title'),
      users: 297,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.countdown.christmashat.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countdown.christmashat.shortDescription'
      ),
      id: TEMPLATES_TITLES.COUNTDOWN_CHRISTMASHAT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmashat-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmashat-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmashat-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-christmashat-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countdown.christmashat.title'),
      users: 802,
    },
  ],
  giveaway: [
    {
      category: i18n.t('screens.templates.giveaway.title'),
      description: i18n.t('screens.templates.giveaway.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.giveaway.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.GIVEAWAY_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/giveaway-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/giveaway-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/giveaway-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/giveaway-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.giveaway.simple.title'),
      users: 5406,
    },
  ],
  medialoop: [
    {
      category: i18n.t('screens.templates.medialoop.title'),
      description: i18n.t('screens.templates.medialoop.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.medialoop.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.MEDIALOOP_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.medialoop.simple.title'),
      users: 7149,
    },
    {
      category: i18n.t('screens.templates.medialoop.title'),
      description: i18n.t(
        'screens.templates.medialoop.socialmedia.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.medialoop.socialmedia.shortDescription'
      ),
      id: TEMPLATES_TITLES.MEDIALOOP_SOCIALMEDIA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-socialmedia-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-socialmedia-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-socialmedia-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-socialmedia-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.medialoop.socialmedia.title'),
      users: 1836,
    },
  ],
  padel: [
    {
      category: i18n.t('screens.templates.padel.title'),
      description: i18n.t('screens.templates.padel.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.padel.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.PADEL_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.padel.simple.title'),
      users: 3075,
    },
    {
      category: i18n.t('screens.templates.padel.title'),
      description: i18n.t(
        'screens.templates.padel.worldPadelTour2021.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.padel.worldPadelTour2021.shortDescription'
      ),
      id: TEMPLATES_TITLES.PADEL_WORLD_PADEL_TOUR_2021,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-world-padel-tour-2021-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-world-padel-tour-2021-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-world-padel-tour-2021-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/padel-world-padel-tour-2021-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.padel.worldPadelTour2021.title'),
      users: 611,
    },
  ],
  question: [
    {
      category: i18n.t('screens.templates.question.title'),
      description: i18n.t('screens.templates.question.twitch.description'),
      shortDescription: i18n.t(
        'screens.templates.question.twitch.shortDescription'
      ),
      id: TEMPLATES_TITLES.QUESTION_TWITCH,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-twitch-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-twitch-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-twitch-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-twitch-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.question.twitch.title'),
      users: 762,
    },
    {
      category: i18n.t('screens.templates.question.title'),
      description: i18n.t('screens.templates.question.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.question.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.QUESTION_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/question-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.question.simple.title'),
      users: 2811,
    },
  ],
  roulette: [
    {
      category: i18n.t('screens.templates.roulette.title'),
      description: i18n.t('screens.templates.roulette.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.roulette.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.ROULETTE_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.roulette.simple.title'),
      users: 14045,
    },
    {
      category: i18n.t('screens.templates.roulette.title'),
      description: i18n.t('screens.templates.roulette.casino.description'),
      shortDescription: i18n.t(
        'screens.templates.roulette.casino.shortDescription'
      ),
      id: TEMPLATES_TITLES.ROULETTE_CASINO,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-casino-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-casino-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-casino-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-casino-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.roulette.casino.title'),
      users: 652,
    },
    {
      category: i18n.t('screens.templates.roulette.title'),
      description: i18n.t('screens.templates.roulette.logo.description'),
      shortDescription: i18n.t(
        'screens.templates.roulette.logo.shortDescription'
      ),
      id: TEMPLATES_TITLES.ROULETTE_LOGO,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-logo-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-logo-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-logo-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/roulette-logo-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.roulette.logo.title'),
      users: 583,
    },
  ],
  soccer: [
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.championsleague2025.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.championsleague2025.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE2025,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague2025-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague2025-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague2025-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague2025-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.championsleague2025.title'),
      users: 1312,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.simple.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.simple.title'),
      users: 26842,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.laligaeasports.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.laligaeasports.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_LALIGAEASPORTS,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligaeasports-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligaeasports-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligaeasports-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligaeasports-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.laligaeasports.title'),
      users: 5795,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.laligahypermotion.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.laligahypermotion.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_LALIGAHYPERMOTION,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligahypermotion-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligahypermotion-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligahypermotion-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligahypermotion-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.laligahypermotion.title'),
      users: 920,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.kingsleague3split.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.kingsleague3split.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_KINGSLEAGUE3SPLIT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague3split-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague3split-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague3split-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague3split-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.kingsleague3split.title'),
      users: 1128,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.premierleague2024.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.premierleague2024.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE2024,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague2024-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague2024-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague2024-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague2024-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.premierleague2024.title'),
      users: 2122,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.eurocup2024.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.eurocup2024.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_EUROCUP2024,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eurocup2024-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eurocup2024-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eurocup2024-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eurocup2024-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.eurocup2024.title'),
      users: 1254,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.copaamerica2024.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.copaamerica2024.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_COPAAMERICA2024,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-copaamerica2024-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-copaamerica2024-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-copaamerica2024-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-copaamerica2024-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.copaamerica2024.title'),
      users: 700,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.supercopa2023.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.supercopa2023.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_SUPERCOPA2023,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-supercopa2023-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-supercopa2023-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-supercopa2023-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-supercopa2023-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.supercopa2023.title'),
      users: 384,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.coparey2023.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.coparey2023.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_COPAREY2023,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey2023-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey2023-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey2023-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey2023-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.coparey2023.title'),
      users: 1034,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.championsleague.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.championsleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-championsleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.championsleague.title'),
      users: 3719,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.kingdomcup.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.kingdomcup.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_KINGDOMCUP,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingdomcup-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingdomcup-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingdomcup-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingdomcup-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.kingdomcup.title'),
      users: 728,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.kingsleague2split.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.kingsleague2split.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_KINGSLEAGUE2SPLIT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague2split-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague2split-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague2split-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague2split-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.kingsleague2split.title'),
      users: 879,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.queensleague.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.queensleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_QUEENSLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-queensleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-queensleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-queensleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-queensleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.queensleague.title'),
      users: 474,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.laliga.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.laliga.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_LALIGA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laliga-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laliga-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laliga-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laliga-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.laliga.title'),
      users: 1634,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.premierleague.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.premierleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-premierleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.premierleague.title'),
      users: 446,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.laligue1.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.laligue1.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_LALIGUE1,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligue1-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligue1-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligue1-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligue1-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.laligue1.title'),
      users: 552,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.seriea.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.seriea.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_SERIEA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-seriea-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-seriea-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-seriea-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-seriea-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.seriea.title'),
      users: 647,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.europaleague.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.europaleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_EUROPALEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-europaleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-europaleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-europaleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-europaleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.europaleague.title'),
      users: 603,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.coparey.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.coparey.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_COPAREY,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-coparey-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.coparey.title'),
      users: 1594,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.laligasmartbank.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.laligasmartbank.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_LALIGASMARTBANK,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligasmartbank-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligasmartbank-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligasmartbank-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-laligasmartbank-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.laligasmartbank.title'),
      users: 423,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.kingsleague.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.kingsleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_KINGSLEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-kingsleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.kingsleague.title'),
      users: 531,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.argentinaleague2023.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.argentinaleague2023.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE2023,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague2023-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague2023-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague2023-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague2023-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.argentinaleague2023.title'),
      users: 888,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.argentinaPrimeraNacional2023.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.argentinaPrimeraNacional2023.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_ARGENTINAPRIMERANACIONAL2023,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaPrimeraNacional2023-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaPrimeraNacional2023-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaPrimeraNacional2023-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaPrimeraNacional2023-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t(
        'screens.templates.soccer.argentinaPrimeraNacional2023.title'
      ),
      users: 532,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.argentinaleague.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.argentinaleague.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-argentinaleague-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.argentinaleague.title'),
      users: 720,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.uefaEuro2020.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.uefaEuro2020.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_EUFA_EURO_2020,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eufa-euro-2020-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eufa-euro-2020-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eufa-euro-2020-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-eufa-euro-2020-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.uefaEuro2020.title'),
      users: 492,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t(
        'screens.templates.soccer.worldCup2022official.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.soccer.worldCup2022official.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_WORLDCUP2022OFFICIAL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldCup2022official-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldCup2022official-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldCup2022official-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldCup2022official-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.worldCup2022official.title'),
      users: 1241,
    },
    {
      category: i18n.t('screens.templates.soccer.title'),
      description: i18n.t('screens.templates.soccer.worldCup2022.description'),
      shortDescription: i18n.t(
        'screens.templates.soccer.worldCup2022.shortDescription'
      ),
      id: TEMPLATES_TITLES.SOCCER_WORLDCUP2022,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldcup2022-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldcup2022-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldcup2022-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/soccer-worldcup2022-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.soccer.worldCup2022.title'),
      users: 1642,
    },
  ],
};

const TEMPLATES_CONTANTS = {
  TEMPLATES,
  TEMPLATES_GROUP,
  TEMPLATES_GROUP_TITLES,
  TEMPLATES_IMAGES,
  TEMPLATES_TITLES,
};

export default TEMPLATES_CONTANTS;
